import React, { useState, useEffect, useCallback } from 'react';

export const useTogglePopup = initial => {
  const [isPopupOpen, setState] = useState(initial);
  const $body = document.body;

  const showPopup = (e) => {
    e.preventDefault();

    $body.classList.add('popup_mod');
    setState(true);
  };

  const hidePopup = (e) => {
    e.preventDefault();

    $body.classList.remove('popup_mod')
    setState(false);
  };

  return [isPopupOpen, showPopup, hidePopup];
}